export const VERSION = 'v1.5';
export const appName = 'VuiBet';
